module.exports = __webpack_public_path__ + "img/shoppingicon.154b0b0e.png";